module.exports = "/images/vendor/flag-icon-css/flags/4x3/mk.svg?ed091b887cafb2adbf04a411d7ac40fa";